import { IOwnLogisticsMatrix, TCSVUploadStatus } from "../interfaces/configuration";

export const csvStatusLabelMap = {
  "no-file": { label: "Sin Archivo", color: "#E22727" },
  processed: { label: "Procesado", color: "#007241" },
  "in-process": { label: "En proceso", color: "#3979B5" },
  errors: { label: "Error", color: "#E22727" },
};

export const getCSVUploadStatus = (
  matrix: IOwnLogisticsMatrix[]
): TCSVUploadStatus => {
  if (!matrix.length) return "no-file";
  if (matrix[0]?.errors_aws_key) return "errors";
  if (matrix[0]?.processed) return "processed";
  return "in-process";
};
